import {IconChevronLeft, IconChevronRight} from '@travel-frontend/icons';
import {Block, IconButton} from '@travel-frontend/ui-components';
import {useEffect, useRef} from 'react';

import {BackToHotelsButton} from '@/components/BackToHotelsButton';
import {MapViewport} from '@/components/MapViewport';
import {LoadingOverlay} from '@/modules/hotels/components/MapView/components/LoadingOverlay';
import {CollapseIcon} from '@/modules/hotels/components/MapView/components/SplitView/components/CollapseIcon';
import {Container} from '@/modules/hotels/components/MapView/components/SplitView/components/Container';
import {Filters} from '@/modules/hotels/components/MapView/components/SplitView/components/Filters';
import {HotelList} from '@/modules/hotels/components/MapView/components/SplitView/components/HotelList';
import {MapControls} from '@/modules/hotels/components/MapView/components/SplitView/components/MapControls';

type Props = React.PropsWithChildren<{
  collapse: boolean;
  setCollapse: (collapse: boolean) => void;
  mapViewportElementRef: React.RefObject<HTMLDivElement>;
  filters: React.ReactNode;
  searchNode?: React.ReactNode;
  mapTrigger?: React.ReactNode;
  hotelsToRender: any;
  alternativeLayout?: boolean;
  visible: boolean;
  onClickBackToHotelsButton: () => void;
}>;

export const SplitView: React.FunctionComponent<Props> = ({
  filters,
  searchNode,
  mapTrigger,
  hotelsToRender,
  alternativeLayout,
  collapse,
  setCollapse,
  mapViewportElementRef,
  visible,
  onClickBackToHotelsButton,
  children,
}) => {
  const listElementRef = useRef<HTMLDivElement | null>(null);

  useEffect(
    function scrollToTopWhenHotelsToRenderChange() {
      if (listElementRef.current) {
        listElementRef.current.scrollTop = 0;
      }
    },
    [hotelsToRender]
  );

  return (
    <Container>
      <LoadingOverlay
        // @TODO only show overlay on updates, not initially
        visible={visible}
      />
      <MapControls direction="row">
        <Filters spacing={alternativeLayout ? 2 : 0}>
          {alternativeLayout && <Block>{searchNode}</Block>}
          {mapTrigger}
          {filters}
        </Filters>
        <HotelList ref={listElementRef} display={collapse ? 'none' : undefined}>
          {children}
        </HotelList>
        <CollapseIcon>
          <IconButton
            category="tertiary"
            onClick={() => setCollapse(!collapse)}
          >
            {collapse ? <IconChevronRight /> : <IconChevronLeft />}
          </IconButton>
        </CollapseIcon>
      </MapControls>
      <MapViewport ref={mapViewportElementRef}>
        {!mapTrigger && (
          <BackToHotelsButton
            style={{
              position: 'absolute',
              left: '50%',
              bottom: '0',
              transform: 'translateX(-50%)',
            }}
            onClick={onClickBackToHotelsButton}
          />
        )}
      </MapViewport>
    </Container>
  );
};
